<div>
    <div class="dialog-header">
        <h4 class="text-center text-vb-red bold red-text">Pickup Action Required</h4>
    </div>
    <div class="dialog-content px-3 pb-2">
        <p class="font-size-14 text-center">
            The following auction(s) have items awaiting pickup. You must either schedule a pickup or acknowledge that your items may be forfeited before continuing.
        </p>
        <div *ngFor="let invoice of pendingInvoices" class="invoice-row mb-3 p-3 border rounded">
            <div class="mb-2">
                <strong>{{ invoice.auctionName }}</strong>
                <div class="font-size-12 text-muted">Flagged {{ invoice.pickupFlaggedAt | vbDate }}</div>
            </div>
            <div class="d-flex gap-2 flex-wrap">
                <button
                    class="btn submit-btn bold flex-grow-1"
                    (click)="schedulePickup(invoice.id)">
                    Schedule Pickup
                </button>
                <button
                    class="btn cancel-btn bold flex-grow-1"
                    [disabled]="isAcknowledging(invoice.id)"
                    (click)="acknowledgeForfeiture(invoice.id)">
                    {{ isAcknowledging(invoice.id) ? 'Acknowledging...' : 'Acknowledge I May Forfeit' }}
                </button>
            </div>
        </div>
        <div class="text-center mt-3 logout-wrapper">
            <vb-logout-button [text]="'Log out'"></vb-logout-button>
        </div>
    </div>
</div>
